// extracted by mini-css-extract-plugin
module.exports = {"noPadding":"styles_noPadding__3sW-p"};